
import lang from 'dojo/_base/lang';
import { compose, mdsWidget } from 'dojo/_base/declare';
import template from './EvBookingEditorV2.html?raw';
import topic from 'dojo/topic';

import GenericDialog from '../../moreCore/UI/GenericDialog/GenericDialog';
import '../../moreCore/UI/GenericDialog/GenericDialog';
import {
    EvBookingFormBase,
    EvBookingFormBasePrivilage,
    EvBookingRoomSelector,
    EvBookingSeatingLayout,
    EvBookingTicketCapacity,
    EvBookingNotes,
    EvBookingNotesV3,
    EvBookingFileList,
    EvCastList,
    EvServiceBookingList,
    EvCategoriesList,
    OrchestraEmploymentsList,
    EvProgramList,
    OverlappingBookingsView,
    EvBookingLegacySections,
    EvBookingBooker,
    EvBookingPublicStatus,
    EvBookingCopyForm,
    EvProcessTable,
    MOZ_EvBookingBooker,
    MOZ_EvBookingBase,
    MOZ_EvCastList,
    ClasslevelList,
    DresscodeList,
    DistributionChannelList,
    GenresList,
    InvolvedAddressesEvBooking
} from "../_loadingHelpers/VAMv2";
import { VAM2types, VAMclassNames } from "../_loadingHelpers/VAMv2Types";
import "../EvBooking/Base/EvBookingFormBaseV2";
import "../EvBooking/Base/EvBookingRoomSelector";
import "../EvBooking/Base/EvBookingSeatingLayout";
import "../EvBooking/Base/EvBookingTicketCapacity";
import "../EvBooking/Base/EvBookingNotes";
import "../EvBooking/EvCast/EvCastList";
import "../EvBooking/Files/FilelistEvBooking";
import "../EvBooking/MOZ/AdvertisingFiles/MozAdvertisingFileList";
import "../EvBooking/MOZ/MOZ_ProjectLeaderMixedInfo";
import "../EvBooking/MOZ/PrintFiles/MozPrintFiles";

import "../EvBooking/EvProgram/EvProgramList";
import "../EvBooking/LEGACY/EvBookingLegacySections";
import "./Overlapping/OverlappingBookingsView";
import "../../moreCore/UI/Floating/Menu";
import _TabEnabledMixin from '../../moreCore/UI/Tabbing/_TabEnabledMixin';
import _StatefulSection from '../../moreCore/UI/_StatefulSection/_StatefulSection';
import { ExpandableSection, ExpandableSectionMarkings } from "../../moreCore/UI/Container/ExpandableSectionTypes";
import "../../moreCore/UI/Container/ExpandableSectionTypes";
import GenericEntityView from '../../moreCore/UI/EntityBased/EntityView/GenericEntityView';
import { FeatureHelpers, ToasterHelpers } from "../../more/Helpers";
import MarketingSection from './Marketing/MarketingSection';
import "./Marketing/MarketingSection";
import TodoAppointmentsTable from '../TodoAppointments/TodoAppointmentsTable';
import SalesSection from './Sales/SalesSection';
import "./Sales/SalesSection";
import EvTaskList from './EvTask/EvTaskList';
import "./EvTask/EvTaskList";
import MozAdvertisingFileList from '../EvBooking/MOZ/AdvertisingFiles/MozAdvertisingFileList';
import "../EvBooking/MOZ/MOZ_Ticketing";
import MozPrintFileList from '../EvBooking/MOZ/PrintFiles/MozPrintFiles';

class EvBookingEditorV2 extends compose(_TabEnabledMixin, _StatefulSection) {
	templateString: any = template;

    private headingLabel: HTMLElement;
    private headingBookingName: HTMLElement;
    private formContainer: HTMLElement;
    private sectionOverlappings: MdsLax<InstanceType<typeof ExpandableSection>>;

    private sectionEvTask: HTMLDivElement;
    private expanderEvTask: MdsLax<InstanceType<typeof ExpandableSection>>;
    private evTaskList: MdsLax<InstanceType<typeof EvTaskList>>;

    private sectionDistributionChannels: HTMLDivElement;
    private expanderDistributionChannels: MdsLax<InstanceType<typeof ExpandableSection>>;
    private distributionChannelList: MdsLax<InstanceType<typeof DistributionChannelList>>;

    private sectionGenres: HTMLDivElement;
    private expanderGenres: MdsLax<InstanceType<typeof ExpandableSection>>;
    private genresList: MdsLax<InstanceType<typeof GenresList>>;

    private involvedAddressesListExpander: MdsLax<InstanceType<typeof ExpandableSection>>;
    private involvedAddressesList: MdsLax<InstanceType<typeof InvolvedAddressesEvBooking>>;
    private sectionInvolvedAddresses: HTMLElement;

    private sectionLegacy: HTMLElement;
    private legacyForm: MdsLax<InstanceType<typeof EvBookingLegacySections>>;

    private sectionEvCast: HTMLElement;
    private sectionEvCastMoz: HTMLElement;
    private castList: MdsLax<InstanceType<typeof EvCastList>>;
    private castListMoz: MdsLax<InstanceType<typeof MOZ_EvCastList>>;
    private expanderEvCast: MdsLax<InstanceType<typeof ExpandableSection>>;
    private expanderEvCastMoz: MdsLax<InstanceType<typeof ExpandableSection>>;

    private sectionBooker: HTMLElement;
    private sectionPublicStatus: HTMLElement;
    private publicStatusWidget: MdsLax<InstanceType<typeof EvBookingPublicStatus>>;

    private sectionEvProgram: HTMLElement;
    private programList: MdsLax<InstanceType<typeof EvProgramList>>;
    private expanderEvProgram: MdsLax<InstanceType<typeof ExpandableSection>>;

    private sectionEvProcess: HTMLElement;
    private evProcessTable: MdsLax<InstanceType<typeof EvProcessTable>>;

    private sectionTodoAppointments: HTMLElement;
    private todoAppointmentsTable: MdsLax<InstanceType<typeof TodoAppointmentsTable>>;

    private sectionEvServiceBooking: HTMLElement;
    private serviceBookingList: MdsLax<InstanceType<typeof EvServiceBookingList>>;
    private expanderEvServiceBookings: MdsLax<InstanceType<typeof ExpandableSection>>;

    private sectionEvCategories: HTMLElement;
    private categoriesList: MdsLax<InstanceType<typeof EvCategoriesList>>;
    private expanderEvCategories: MdsLax<InstanceType<typeof ExpandableSection>>;

    private sectionMarketing: HTMLElement;
    private marketingEditor: MdsLax<InstanceType<typeof MarketingSection>>;
    private expanderMarketing: MdsLax<InstanceType<typeof ExpandableSection>>;

    private sectionSales: HTMLElement;
    private salesEditor: MdsLax<InstanceType<typeof SalesSection>>;
    private expanderSales: MdsLax<InstanceType<typeof ExpandableSection>>;

    private sectionFilelist: HTMLElement;
    private filelist: MdsLax<InstanceType<typeof EvBookingFileList>>;
    private mozFilelist: MdsLax<InstanceType<typeof MozAdvertisingFileList>>;
    private mozPrintFilelist: MdsLax<InstanceType<typeof MozPrintFileList>>;
    private expanderFilelist: MdsLax<InstanceType<typeof ExpandableSection>>;

    private sectionOrchestraEmployments: HTMLElement;
    private orchestraEmploymentsList: MdsLax<InstanceType<typeof OrchestraEmploymentsList>>;
    private expanderOrchestraEmployments: MdsLax<InstanceType<typeof ExpandableSection>>;

    private sectionClasslevel: HTMLElement;
    private classLevelList: MdsLax<InstanceType<typeof ClasslevelList>>;
    private expanderClasslevel: MdsLax<InstanceType<typeof ExpandableSection>>;

    private sectionDresscode: HTMLElement;
    private dresscodeList: MdsLax<InstanceType<typeof DresscodeList>>;
    private expanderDresscode: MdsLax<InstanceType<typeof ExpandableSection>>;

    private baseForm: MdsLax<InstanceType<typeof EvBookingFormBase>>;
    private baseFormPriv: MdsLax<InstanceType<typeof EvBookingFormBase>>;
    private noteBase: MdsLax<InstanceType<typeof EvBookingNotes>>;
    private locationForm: MdsLax<InstanceType<typeof EvBookingRoomSelector>>;
    private seatingLayoutForm: MdsLax<InstanceType<typeof EvBookingSeatingLayout>>;
    private ticketsCapacityForm: MdsLax<InstanceType<typeof EvBookingTicketCapacity>>;
    private overlappingsForm: MdsLax<InstanceType<typeof OverlappingBookingsView>>;
    private dlg: MdsLax<InstanceType<typeof GenericDialog>> = null;

    private entity: VAM2types.EvBooking_Extended;
    //private entityId: string = null;

    private sectionVisitor: HTMLElement;

    protected sectionEntityView_Top: HTMLElement;
    protected EntityViewContainer_Top: HTMLElement;
    protected sectionEntityView_MiddleTop: HTMLElement;
    protected EntityViewContainer_MiddleTop: HTMLElement;
    protected sectionEntityView_Bottom: HTMLElement;
    protected EntityViewContainer_Bottom: HTMLElement;

    private readonly: boolean = true;

    _request: any = null;

    private selfSetup() {
        if (this.isStarted) return;
        if (this.isEmbeddedInTab == true || this.dlg || this.domNode.parentNode) return; // setup war schon
        let id = this.entityId ? this.entityId : (Math.random() * 10000).toString();

        let isNew = this.entityId ? false : true;

        // das Widget versucht hier, sich als Tab anzumelden
        this.createNewTabbedContent({
            enableClosing: true,
            label: this.entity && this.entityId ? this.entity.ev_booking_name ? this.entity.ev_booking_name : this.translations["General_Label_EvBooking"] : this.translations["BookingEditor__CreateNewBooking"],
            name: id,
            sidebarEntryName: id,
            widget: this,
            iconclass: "fas fa-edit"
        }, true);

        // falls das nicht gelingt, wird ein Dlg erzeugt:
        if (this.isEmbeddedInTab) {



            //this.requestTabswitch(this.internalName);
        } else {
            this.dlg = new GenericDialog();

            this.dlg.keepOpen = true;

            this.dlg.show(
                this.formContainer,
                this.translations["EvBookingditor_dialogHeader"],
                null,
                null,
                "saveclose",
                lang.hitch(this, this._onDlgResult)
            );

            this.dlg.on("closed", lang.hitch(this, this._onDlgClosed));
            this.dlg.addButton("save", this.translations["General_Save"], lang.hitch(this, this.saveData), null, "accentBG", "fas fa-save", false, "first");
            if(!isNew) this.dlg.disableButton("save");
        }
    }

    loadDefaultValues(project: more.EntityAPIResultExtended) {
        this.StandbyStart();
        this.RequestManager.callfunction("Webtool_API_EvBooking__LoadDefaultValues", { projectID: project.ID }, lang.hitch(this, this._onLoadDefaultValuesResponse), lang.hitch(this, this._onLoadDefaultValuesError));
    }

    private _onLoadDefaultValuesResponse(response: Record<string, any>) {
        this.StandbyStop();
        this.showToast({ title: "General_Success_LoadDefaultValues", iconClass: "fas fa-check", timeout: 2000 });
        for (let key of Object.keys(response)) {
            this.setAttributeValue(key, response[key]);
        }
    }

    private _onLoadDefaultValuesError(error: more.requestErrorMessage) {
        this.StandbyStop();
        this.showToast({ title: "General_Error_LoadDefaultValues", iconClass: "fas fa-exclamation-triangle", timeout: 5000 });
    }

    private _onDlgResult(result: number) {
        if (result <= 0) {

            this.dlg.close(-1, true);
        }
    }

    private _onDlgClosed(result: any) {
        this.emit("closed");
    }

    private cloneBooking() {
        if (!this.entity) return;
        console.debug("cloneBooking", this.entity);
        let cloneForm = new EvBookingCopyForm();;
        cloneForm.setup(this.entity);

        //cloneForm.on("saved", lang.hitch(this, this._onSavedClone));
    }

    onDirtyChange(dirtyState: boolean) {
        let isNew = this.entityId == null;

        if (this.isEmbeddedInTab) {
            this.createDefaultButton("save", lang.hitch(this, this.saveData))

            this.requestContextButtonDisable("save", dirtyState);
            this.requestContextButtonDisable("rollback", dirtyState && !isNew);

        } else if (this.dlg) {
            dirtyState ? this.dlg.enableButton("save") : this.dlg.disableButton("save");
            !isNew && dirtyState ? this.dlg.enableButton("rollback") : this.dlg.disableButton("rollback");
        }
    }

    private saveData(): boolean {
        if (this._request != null) {
            return false;
        }

        if (this.checkMandatoryInputs() != true) {
            this.showToast({
                title: this.translations["General_MandatoryMissing"],
                iconClass: ToasterHelpers.ToasterIcons.warning
            });
            return false;
        }

        this.StandbyStart(this.formContainer);
        if (this.dlg) this.dlg.disableButton("save");

        setTimeout(lang.hitch(this, this.continueSaveData), 350); // onchangeds abwarten :-/

        return true;
    }

    private continueSaveData() {

        let data = lang.clone(this.changedData) as VAM2types.EvBooking_Base;


        // Zeitzonen entfernen.
        if (data.date_start) {
            data.date_start = this.dateToLocalISOString(data.date_start) as any;
        }

        if (data.date_end) {
            data.date_end = this.dateToLocalISOString(data.date_end) as any;
        }

        if (this.entityId) data.ID = this.entityId;

        if (this.hasUserRole("_DEV")) console.log(this.id + " saveData:", data, this.changedData);


        this._request = this.RequestManager.callfunction(
            "Webtool_API_EvBooking__SaveFormData",
            data,
            lang.hitch(this, this._onSaveDataResponse),
            lang.hitch(this, this._onSaveDataError));

    }

    private _onSaveDataResponse(response) {
        this._request = null;
        //this.StandbyStop();

        if (response.ID) {
            this.showToast({
                title: this.translations["General_SavingSuccessful"],
                iconClass: ToasterHelpers.ToasterIcons.confirmCheck,
                options: {
                    ID: this.entityId
                }
            });

            this.emit("saved", response);
            topic.publish("EvBooking/Saved", response);

            if (this._destroyed) return;
            this.resetDirty();
            this.loadEntityById(response.ID);

        } else {
            alert(this.id + " - unexpected response after saving: " + response);
            this.StandbyStop();
            if (this.dlg) this.dlg.enableButton("save");
        }
    }

    private _onSaveDataError(error: more.requestErrorMessage) {
        this._request = null;
        this.StandbyStop();
        if (this.dlg) this.dlg.enableButton("save");

        this.showToast({
            title: this.translate("General_SavingFailed"),
            iconClass: ToasterHelpers.ToasterIcons.error,
            message: error.Message,
            options: {
                ID: this.entityId,
                timeout: 20000,
                closeButton: true
            }
        });
    }

    setEntity(entity: VAM2types.EvBooking_Extended) {
       this.setData(entity);
    }



    setData(entity) {

        if (!entity) return;

        let id = entity.ID;
        if (id != this.entityId) this.isPrivilegesLoaded = false;

        this.entity = entity;
        this.entityId = id;
        this.sourceData = lang.clone(entity);

        //entity["LEGACY"] = {}; // garned so geil, dann gibts auf der Legacy-Data dieses Legacy-Property auch wieder, aber ohne Inhalt.

        if (!this.isPrivilegesLoaded) {
            // Abzweigen: erst mal asynchron Rechte checken. dann kommen wir wieder her
            this.webPrivilegeManager.loadPrivilegesForEntity(this.entityId ? this.entity : null, lang.hitch(this, this._onPrivilegesLoaded));

            return;
        }
        this.selfSetup();
        super.setData.apply(this, arguments as any);

    }

    afterSetData() {
        let data = this.sourceData as VAM2types.EvBooking_Extended;
        if (this.entityId) {
            this._onDisplaynameChange(data.ev_booking_name);
            if (this.isEmbeddedInTab) {
                if (this.hasUserRole("EvBooking_Delete", null, data)) {
                    this.createDefaultButton("deleteWithConfirmationDlg", lang.hitch(this, this.deleteEvBooking));
                }
            }

            else if (this.dlg) {
                this.dlg._setHeaderAttr(data.ev_booking_name);

                if (this.hasUserRole("EvBooking_Delete")) {

                }
            }
        }

        if (this.seatingLayoutForm && data?.ref_ev_room && this.hasFeature("EvBooking/SeatingLayout")) {
            this.seatingLayoutForm.setRoomId(data.ref_ev_room.ID, false);
            this.disableNode(this.seatingLayoutForm.domNode, false);
        }

        if (this.overlappingsForm && this.hasFeature("EvBooking/Overlappings")) {
            this.checkOverlappings();
        }


        this.programList.setup(this.entity?.program, this.entityId, this.getAttributeValue("sync_type_ev_program"));
        this.castList.setup(this.entity?.cast, this.entityId, this.getAttributeValue("sync_type_ev_cast"));


        if (FeatureHelpers.hasFeature("EvBooking/Marketing") && this.hasUserRole("EvBooking_Marketing")) {
            this.expanderMarketing.setMarking(this.marketingEditor.hasData() ? ExpandableSectionMarkings.hasContent : ExpandableSectionMarkings.default);
            this.marketingEditor.disableWebCheckbox(this.getAttributeValue("ref_ev_activity_status.is_event"));
        }

        if (FeatureHelpers.hasFeature("EvBooking/Sales") && this.hasUserRole("EvBooking_Sales")) {
            this.expanderSales.setMarking(this.salesEditor.hasData() ? ExpandableSectionMarkings.hasContent : ExpandableSectionMarkings.default);

        }

        if (this.hasFeature("EvBooking/EvTask") && this.hasUserRole("EvBooking_EvTask")) {
            this.expanderEvTask.setMarking(this.evTaskList.hasData() ? ExpandableSectionMarkings.hasContent : ExpandableSectionMarkings.default);
        }

        if (this.hasFeature("EvBooking/DistributionChannels") && this.hasUserRole("EvBooking_DistributionChannels")) {
            this.expanderDistributionChannels.setMarking(this.distributionChannelList.hasData() ? ExpandableSectionMarkings.hasContent : ExpandableSectionMarkings.default);
            this.distributionChannelList.updateSedFilterValues("ref_ev_project", this.getAttributeValue("ref_ev_project"));
        }

        if (this.hasFeature("EvBooking/Genres") && this.hasUserRole("EvBooking_Genres")) {
            this.expanderGenres.setMarking(this.genresList.hasData() ? ExpandableSectionMarkings.hasContent : ExpandableSectionMarkings.default);
        }

        let isPublic = this.getAttributeValue("is_public") !== false;
        if (!this.hasFeature("EvBooking/PublicCapacityAlwaysEnabled")) this.ticketsCapacityForm.setReadonly(!isPublic);

        this.setAttributeValue("service", null);
        this.setAttributeValue("serviceCanceled", null);


        this._setupEntityViews();

        if (this.hasFeature("Mozarteum/BookingBase")) {
            setTimeout(() => { this._handleActivityStatusMOZ(data.ref_ev_activity_status); }, 150)
        }

        this.monitorIsPublicState("start");

        this.resetDirty();
    }

    private _monitorTimeoutHandler: any = null;
    private monitorIsPublicState(triggerSource: "start" | "ref_ev_activity_status" | "ref_ev_room" | "is_public" | "distributionChannel", oldValue?: any): void {

        let isPublicBooking: boolean = this.getAttributeValue("is_public") !== false;
        let isPublicActivityStatus: boolean = this.getAttributeValue("ref_ev_activity_status")?.is_with_public !== false;
        let isPublicRoom: boolean = this.getAttributeValue("ref_ev_room")?.is_with_public !== false;

        let canBePublic = isPublicRoom && isPublicActivityStatus;


        // prüft jetzt, ob Änderung zulässig, weil ggf. schon Vertriebskanäle etc dran hängen
        if (this.hasFeature("EvBooking/MonitorIsPublicState") && this.hasUserRole("EvBooking_DistributionChannels") && this.hasFeature("EvBooking/DistributionChannels")) {

            // get bool values
            let hasDistribution: boolean = this.distributionChannelList.hasData();
            let reverseChange: boolean = false;

            // account changes for distribution channels
            if (hasDistribution === true) {

                switch (triggerSource) {
                    case "ref_ev_activity_status":
                        if (!isPublicActivityStatus) reverseChange = true;
                        break;
                    case "ref_ev_room":
                        if (!isPublicRoom) reverseChange = true;
                        break;
                    case "is_public":
                        if (!isPublicBooking) {
                            reverseChange = true;
                            oldValue = true;
                        }
                        break;
                    default:
                }
            }

            // show msg
            if (reverseChange) {

                this.setAttributeValue(triggerSource, oldValue);

                if (triggerSource == "ref_ev_activity_status" && this.hasUserRole("EvBooking_OM")) this.setAttributeValue("is_employment", oldValue.is_employment);
                let dlg = new GenericDialog();

                dlg.show(this.translate(`EvBookingEditor_IsPublic_ChangeNotValid_MSG_${triggerSource}`),
                    this.translate("General_Error"),
                    null,
                    "fas fa-exclamation-triangle warningTXT",
                    "ok");

                switch (triggerSource) {
                    case "ref_ev_activity_status":
                        isPublicActivityStatus = oldValue;
                        break;
                    case "ref_ev_room":
                        isPublicRoom = oldValue;
                        break;
                    case "is_public":
                        if (this._monitorTimeoutHandler != null) clearTimeout(this._monitorTimeoutHandler);
                        this._monitorTimeoutHandler = setTimeout(lang.hitch(this, this.setAttributeValue, triggerSource, oldValue), 100)
                        break;
                }
            }

            canBePublic = isPublicRoom && isPublicActivityStatus;

            // adjust is_public value
            //this.disableNode(this.sectionPublicStatus, !publicActivityStatus || !publicRoom);
            if (triggerSource != "start" && this.hasUserRole("EvBooking_OM")) {
                let acs = this.getAttributeValue("ref_ev_activity_status");
                if (acs && acs?.is_employment !== this.getAttributeValue("is_employment")) this.setAttributeValue("is_employment", acs.is_employment);
            }

            this.distributionChannelList.disableEdit(canBePublic === false);
        }

        let targetPublicStatus = isPublicBooking;
        if ((triggerSource == "ref_ev_activity_status" || triggerSource == "ref_ev_room") && canBePublic == true) targetPublicStatus = canBePublic;
        if (isPublicBooking && !canBePublic) targetPublicStatus = false || this.hasFeature("EvBooking/PublicCapacityAlwaysEnabled");

        
            if (this.publicStatusWidget) {
                if (!this.hasFeature("EvBooking/PublicCapacityAlwaysEnabled")) this.publicStatusWidget.setReadonly(canBePublic === false);
                if (triggerSource != "start" && triggerSource != "is_public") {
                    this.publicStatusWidget.setAttributeValue("is_public", targetPublicStatus);
                } 
        }

        this.setAttributeValue("is_public", targetPublicStatus);

        if (this.ticketsCapacityForm && !this.hasFeature("EvBooking/PublicCapacityAlwaysEnabled")) this.ticketsCapacityForm.setReadonly(targetPublicStatus === false);

    }

    reloadEntity(): void {
        this.loadEntityById(this.entityId);
    }
    loadEntityById(entityId: string): void {

        this.entityId = entityId;

        if (!this.entityId) return;

        this.startup();

        this.isPrivilegesLoaded = false;

        this.StandbyStart(this.formContainer);

        this.disableNode(this.formContainer);

        if (this._request != null) {
            this._request.cancel();
        }

        this.setStartupState("loading");

        let data = { ID: entityId };

        this._request = this.RequestManager.callfunction("Webtool_API_EvBooking__GetEntityById",
            data,
            lang.hitch(this, this._onLoadEntityByIdResult),
            lang.hitch(this, function (err: more.requestErrorMessage) {
                this.StandbyStop();
                this._request = null;
                if (err && err.Message) {
                    alert(err.Message);
                } else {
                    console.log(err);
                }
            })
        );

    }

    private _onLoadEntityByIdResult(response: VAM2types.EvBooking_Extended): void {

        if (this._destroyed) return;

        this.disableNode(this.formContainer, false);
        this._request = null;
        this.setEntity(response);

        this.StandbyStop();

    }

    private deleteEvBooking() {
        if (!this.hasUserRole("EvBooking_Delete")) return;

        if (!this.entity || !this.entity.ID) {
            return;
        }

        this.StandbyStart();

        let data = {
            entityID: this.entity.ID
        };

        let url = window.appRoot + "EvBooking/DeleteEvBooking";

        this.RequestManager.post(
            url,
            {
                "jsonData": JSON.stringify(data)
            },
            lang.hitch(this, this._onDeleteEvBookingResponse),
            lang.hitch(this, this._onDeleteEvBookingError),
            false // sync
        );
    }

    private _onDeleteEvBookingResponse(response: { Exception: boolean, Message: string }) {

        this.StandbyStop();

        this.showToast({
            title: this.translations["General_DeletingSuccessful"],
            iconClass: ToasterHelpers.ToasterIcons.confirmCheck
        });

        if (this.isEmbeddedInTab) {
            this.closeTab();
        }

        this.emit("entityDeleted");
    }

    private _onDeleteEvBookingError(error: more.requestErrorMessage) {
        this.StandbyStop();

        let dlg = new GenericDialog();
        dlg.show(error.Message,
            this.translations["General_DeletingFailed"],
            null, ToasterHelpers.ToasterIcons.error, "close");
    }
    _onEmbedding() {
        this.UiModder.domClass.toggle(this.domNode, "border round padding", this.isEmbeddedInTab);
        this.hideNode(this.headingLabel, !this.isEmbeddedInTab);
    }
    protected _onDisplaynameChange(newName: string) {
        this.headingBookingName.innerHTML = newName;
        this.hideNode(this.headingBookingName, false);

        this.requestTabRename(newName);
    }
    _onCloseRequest(): boolean {
        if (this.isDirty()) {
            let dlgConfirm = new GenericDialog();
            dlgConfirm.setSize("smaller");
            dlgConfirm.show(this.translations["General_AskSavePendingChanges"],
                this.translations["General_PendingChanges"],
                "",
                "",
                "yesnocancel",
                lang.hitch(this, this._confirmCallback));

            return false;

        } else {
            return true;
        }
    }

    private _confirmCallback(result) {
        if (result == -1) { // nein
            this.closeTab();
        } else if (result == 0) { // cancel

        }
        else {
            if (this.saveData() == true) {
                this.on("saved", lang.hitch(this, this.closeTab));
            }
        }

    }

    private currentCastWidget: {}

    _handleActivityStatusMOZ(newValue: VAM2types.EvActivityStatus) {
        if (newValue?.description == "Studienkonzert" || newValue?.description == "Probe Sekretariate") {
            this.hideNode(this.sectionEvCast, false); // bei Studienkonzerten muss der CastEditor ohne Professor geladen werden
            this.hideNode(this.sectionEvCastMoz, true);

            this.currentCastWidget = this.castList;
        } else {
            this.hideNode(this.sectionEvCastMoz, false);
            this.hideNode(this.sectionEvCast, true);

            this.currentCastWidget = this.castListMoz;
        }
    }

    _onChanged_ActivityStatus(attr: string, newValue: VAM2types.EvActivityStatus, oldValue: any) {
        //console.log(newValue);
        if (this.hasFeature("Mozarteum/BookingBase")) {
            this._handleActivityStatusMOZ(newValue);
            this._handleAutomaticNamingMOZ();
        }

        //this.setAttributeValue("ref_ev_activity_status", newValue);
        this.monitorIsPublicState("ref_ev_activity_status", oldValue);
        if (FeatureHelpers.hasFeature("EvBooking/Marketing") && this.hasUserRole("EvBooking_Marketing")) {
            this.marketingEditor.disableWebCheckbox(newValue ? newValue["is_event"] : false);
        }
    }

    private _onChange_EvCastMoz() {

        let listResponse = this.castListMoz.getData();

        let list = listResponse.entitylist;
        list.length ? this.expanderEvCastMoz.setMarking(ExpandableSectionMarkings.hasContent) : this.expanderEvCastMoz.setMarking(ExpandableSectionMarkings.default);
        let newCastData = this.castListMoz.getDiffData();

        console.debug(this.id + " _onChange_EvCastMoz", newCastData, list);

        this._handleAutomaticNamingMOZ();
        this.setAttributeValue("cast", newCastData);
    }

    private _handleAutomaticNamingMOZ() {
        let activity = this.getAttributeValue("ref_ev_activity_status.description");
        //let cast = this.getAttributeValue("cast");
        if (this.currentCastWidget) {
            let cast = (this.currentCastWidget as any).getData();

            //console.log("_handleAutomaticNaming", activity, cast);

            let firstCast = cast.entitylist[0];

            if (!firstCast) {
                return "";
            }

            let automaticName = "";
            if (this.hasUserRole("Sekretariat") || this.hasUserRole("Pruefung")) {
                // „Art der Prüfung + Studierenden + Lehrprofessor + Fach“

                if (firstCast.ref_teaching_professor) {
                    automaticName = `${activity} (${firstCast.ref_performer.ref_address.pseudonym}) (${firstCast.ref_teaching_professor.gDisp_1}) ${firstCast.ref_performer.ref_ev_profession.description}`;
                } else {
                    automaticName = `${activity} (${firstCast.ref_performer.ref_address.pseudonym}) ${firstCast.ref_performer.ref_ev_profession.description}`;
                }
            }

            if (automaticName.length > 0 && this.getAttributeValue("ev_booking_name") == null) {
                this.removeToast("automaticNameToast");

                this.showToast({
                    title: "Hier klicken um den Buchungsname aus den eingegebenen Daten zu generiert.",
                    options: {
                        onClick: lang.hitch(this, this._setAutomaticName, automaticName)
                    },
                    ID: "automaticNameToast",
                    timeout: "permanent"
                });
            }


            return automaticName;
        }

        return "";
    }

    private _setAutomaticName(name: string) {
        this.setAttributeValue("ev_booking_name", name);
    }

    _onChanged_EvRoom(attr: string, newValue: VAM2types.EvRoomEntity, oldValue: any) {
        //console.debug(this.id + " ROOM CHANGED " + attr, newValue);

        // FAQ: wo wird hier die Overlapping ausgelöst?
        // A: garnicht. die wird im allgemeinen _onChanged weiter unten abgefragt!

        // falls Seating-Layout: die Section muss sich neu laden
        if (this.seatingLayoutForm && this.hasFeature("EvBooking/SeatingLayout")) {
            //this.setAttributeValue("ref_audience_seating_layouts", null);
            this.seatingLayoutForm.setRoomId(newValue?.ID, true);
            this.disableNode(this.seatingLayoutForm.domNode, !newValue?.ID);
        }

        this.setAttributeValue("ref_ev_room", newValue);
        this.monitorIsPublicState("ref_ev_room", oldValue);
        if (this.hasFeature("EvBooking/DistributionChannels")) this.distributionChannelList.updateSedFilterValues(attr, newValue);

        if (this.hasFeature("EvBooking/EvService") && this.serviceBookingList) this.serviceBookingList?.setRoomId(newValue?.ID);
    }

    _onChanged_Dates(attr: string, newValue: Date, oldValue: any) {
        //console.debug(this.id + " _onChanged_Dates " + attr, newValue);

        // Datumsänderungen durchreichen, damit der Roomselektor das in seinen Loading-Request aufnehmen kann
        if (this.locationForm) {
            this.locationForm.setRequestData(this.currentData.date_start, this.currentData.date_end, this.entityId);
        }
        if (this.hasFeature("EvBooking/DefaultProjectByDate") && !this.entityId) {
            if (this.hasFeature("EvBooking/BasePrivilage")) this.baseFormPriv.emit("defaultProject_presetBooking", this.currentData.date_start);
            else this.baseForm.emit("defaultProject_presetBooking", this.currentData.date_start);
        }

        if (this.hasFeature("EvBooking/DistributionChannels")) this.distributionChannelList.updateSedFilterValues(attr, newValue);
    }

     _onChanged_SeatingLayout(attr: string, newValue: any, oldValue: any) {
         //console.debug(this.id + " _onChanged_SeatingLayout " + attr, newValue);

         if (newValue && this.hasFeature("EvBooking/TicketsCapacity")) {
             this.ticketsCapacityForm.onNewSeatingLayout(newValue);
         }
    }

    _onChanged(key: string, value: any) {
        switch (key) {
            case "ref_ev_room":
                if (this.hasFeature("EvBooking/EvBookingNameCityPrefix") && !this.entityId) {
                    topic.publish("EvBookingNameCityPrefix_Changed_EvRoom", value["city"])
                }
                // Überschneidungen prüfen!
                this.checkOverlappings();
                break;
            case "date_start":
            case "date_end":
            case "is_full_time":
                // Überschneidungen prüfen!
                this.checkOverlappings();
                break;

            case "cast":
                break;
            case "is_public":
                break;
        }

        //console.debug(this.id + " onchanged: " + key, this.changedData, this.currentData);


    }

    private _setupEntityViews() {

        this.hideNode(this.sectionEntityView_Top);
        this.UiModder.domConstruct.empty(this.EntityViewContainer_Top);

        this.hideNode(this.sectionEntityView_MiddleTop);
        this.UiModder.domConstruct.empty(this.EntityViewContainer_MiddleTop);

        this.UiModder.domConstruct.empty(this.EntityViewContainer_Bottom);
        this.hideNode(this.sectionEntityView_Bottom);

        if (!this.entityId) return;

        if (this.hasFeature("EvBooking/EntityViewInEditor_Top")) {

            let entityview = new GenericEntityView();

            entityview.setup(this.entityId,
                VAMclassNames.ev_booking,
                this.getDisplayname(),
                "ev_booking_name",
                this.EntityViewContainer_Top,
                null,
                "evBookingEditor_Top");

            entityview.hideIfEmpty(true, lang.hitch(this, this.hideNode, this.sectionEntityView_Top));

        }
        if (this.hasFeature("EvBooking/EntityViewInEditor_MiddleTop")) {

            let entityview = new GenericEntityView();

            entityview.setup(this.entityId,
                VAMclassNames.ev_booking,
                this.getDisplayname(),
                "ev_booking_name",
                this.EntityViewContainer_MiddleTop,
                null,
                "evBookingEditor_MiddleTop");

            entityview.hideIfEmpty(true, lang.hitch(this, this.hideNode, this.sectionEntityView_MiddleTop));

        }
        if (this.hasFeature("EvBooking/EntityViewInEditor_Bottom")) {
            this.hideNode(this.sectionEntityView_Bottom, false);

            let entityview = new GenericEntityView();

            entityview.setup(this.entityId,
                VAMclassNames.ev_booking,
                this.getDisplayname(),
                "ev_booking_name",
                this.EntityViewContainer_Bottom,
                null,
                "evBookingEditor_Bottom");

            entityview.hideIfEmpty(true, lang.hitch(this, this.hideNode, this.sectionEntityView_Bottom));

        }
    }

    private checkOverlappings() {
        if (!this.hasFeature("EvBooking/Overlappings")) return;

        let data = this.currentData as VAM2types.EvBooking_Extended;

        if (this.overlappingsForm && data) {
            this.overlappingsForm.setup({
                selfBookingId: this.entityId ? this.entityId : null,
                start: data.date_start,
                end: data.date_end,
                roomId: data.ref_ev_room?.ID,
                isWithRoomList: false
            }, this.isDirty() ? null : 100);
        }
    }
    private _onOverlappingsLoaded() {
        let count = this.overlappingsForm.getOverlappingsCount();

        let isOverlapping = count > 0;

        this.hideNode(this.sectionOverlappings.domNode, !isOverlapping);

        this.sectionOverlappings.toggleExpand(isOverlapping, true);
        this.sectionOverlappings.setExpandable(isOverlapping);

        if (isOverlapping) {
            this.sectionOverlappings.setMarking(ExpandableSectionMarkings.warning);
        } else {
            this.sectionOverlappings.setMarking(ExpandableSectionMarkings.checked);

        }
    }

    private _onDirty_LegacyForm(dirty: boolean) {
        let data = this.legacyForm.getCurrentData();
        let diffData = this.legacyForm.getChangedData();

        console.debug(this.id + " _onDirty_LegacyForm", diffData, data);

        if (dirty) {
            this.currentData["LEGACY"] = data;
            this.changedData["LEGACY"] = data;
            this.isDirty(true);
        } else {

        }
    }

    private _onChange_Files() {
        let filesData = this.filelist.getData();

        this.setAttributeValue("files", filesData, true);

        if (filesData?.new?.length || filesData?.changed?.length || filesData?.deleted?.length) {
            this.expanderFilelist.setMarking(ExpandableSectionMarkings.hasContent);
        } else {
            this.expanderFilelist.setMarking(ExpandableSectionMarkings.default);
        }

    }

    private _onChange_MozFiles() {
        let filesData = this.mozFilelist.getData();

        this.setAttributeValue("mozFiles", filesData, true);

        /*if (filesData?.new?.length || filesData?.changed?.length || filesData?.deleted?.length) {
            this.expanderFilelist.setMarking(ExpandableSectionMarkings.hasContent);
        } else {
            this.expanderFilelist.setMarking(ExpandableSectionMarkings.default);
        }*/

    }

    private _onChange_MozPrintFiles() {
        let filesData = this.mozPrintFilelist.getData();

        this.setAttributeValue("mozPrintFiles", filesData, true);

        /*if (filesData?.new?.length || filesData?.changed?.length || filesData?.deleted?.length) {
            this.expanderFilelist.setMarking(ExpandableSectionMarkings.hasContent);
        } else {
            this.expanderFilelist.setMarking(ExpandableSectionMarkings.default);
        }*/

    }

    private _onChange_EvCategory(diffData) {
        let list = this.categoriesList.getData();
        this.expanderEvCategories.setMarking(list.length ? ExpandableSectionMarkings.hasContent : ExpandableSectionMarkings.default);

        if (diffData != null) {
            let newData = this.categoriesList.getDiffData();

            console.debug(this.id + " _onChange_EvCategory", newData, list);

            this.setAttributeValue("evCategories", newData);
        } else {
            this.setAttributeValue("evCategories", null);
        }
    }

    private _onChange_EvCast() {

        let data = this.castList.getData();
        let list = data.entitylist;
        list.length ? this.expanderEvCast.setMarking(ExpandableSectionMarkings.hasContent) : this.expanderEvCast.setMarking(ExpandableSectionMarkings.default);
        let newCastData = this.castList.getDiffData();

        console.debug(this.id + " _onChange_EvCast", newCastData, list);

        this.setAttributeValue("sync_type_ev_cast", data.syncMode);

        this.setAttributeValue("cast", newCastData);

        if (this.hasFeature("Mozarteum/EvCast")) {
            this._handleAutomaticNamingMOZ();
        }
    }
     private _onChange_EvProgram() {
         let data = this.programList.getData();
         let list = data.entitylist;

         this.expanderEvProgram.setMarking(list.length ? ExpandableSectionMarkings.hasContent : ExpandableSectionMarkings.default);


         let newProgramData = this.programList.getDiffData();

         console.debug(this.id + " _onChange_EvCast", newProgramData, list);

         this.setAttributeValue("program", newProgramData);

         this.setAttributeValue("sync_type_ev_program", data.syncMode);
    }
    private _onResourceOverload_EvServiceBookings(isOverloaded: boolean) {
        this.expanderEvServiceBookings.setMarking(isOverloaded ? ExpandableSectionMarkings.warning : ExpandableSectionMarkings.hasContent);
    }
    private _onChange_EvServiceBookings(diffData) {
        let list = this.serviceBookingList.getData();
        let canceledList = this.serviceBookingList.getDataCanceled();
        this.expanderEvServiceBookings.setMarking(list?.length || canceledList?.length ? ExpandableSectionMarkings.hasContent : ExpandableSectionMarkings.default);

        if (diffData != null) {
            let newData = this.serviceBookingList.getDiffData();

            //console.debug(this.id + " _onChange_EvServices", newData, list);

            this.setAttributeValue("service", newData);
            
        } else {

            this.setAttributeValue("service", null);
        }
    }
    private _onChange_EvServiceBookingsCanceled(diffData) {
        let list = this.serviceBookingList.getData();
        let canceledList = this.serviceBookingList.getDataCanceled();
        this.expanderEvServiceBookings.setMarking(list?.length || canceledList?.length ? ExpandableSectionMarkings.hasContent : ExpandableSectionMarkings.default);

        if (diffData != null) {
            let newData = this.serviceBookingList.getDiffDataCanceled();

            //console.debug(this.id + " _onChange_EvServicesCanceled", newData, list);

            this.setAttributeValue("serviceCanceled", newData);

        } else {
            this.setAttributeValue("serviceCanceled", null);
        }
    }
    private _onChange_OrchestraEmployments() {
        let list = this.orchestraEmploymentsList.getData();
        this.expanderOrchestraEmployments.setMarking(list.length ? ExpandableSectionMarkings.hasContent : ExpandableSectionMarkings.default);
        let newOrchestraEmploymentsData = this.orchestraEmploymentsList.getDiffData();

         console.debug(this.id + " _onChange_OrchestraEmployments", newOrchestraEmploymentsData, list);

         this.setAttributeValue("orchestraEmployments", newOrchestraEmploymentsData);
    }

    private _onChange_Marketing(data) {
        this.expanderMarketing.setMarking(this.marketingEditor.hasData() ? ExpandableSectionMarkings.hasContent : ExpandableSectionMarkings.default);
        this.marketingEditor.disableWebCheckbox(this.getAttributeValue("ref_ev_activity_status.is_event"));
    }

    private _onChange_Sales(data) {
        this.expanderSales.setMarking(this.salesEditor.hasData() ? ExpandableSectionMarkings.hasContent : ExpandableSectionMarkings.default);
    }

    private _onChange_DistributionChannels(data) {
        this.expanderDistributionChannels.setMarking(this.distributionChannelList.hasData() ? ExpandableSectionMarkings.hasContent : ExpandableSectionMarkings.default);

        this.monitorIsPublicState("distributionChannel");
    }

    private _onChange_Genres(data) {
        this.expanderGenres.setMarking(this.genresList.hasData() ? ExpandableSectionMarkings.hasContent : ExpandableSectionMarkings.default);
    }

    private _onReloaded_DistributionChannels() {
        this.expanderDistributionChannels.setMarking(this.distributionChannelList.hasData() ? ExpandableSectionMarkings.hasContent : ExpandableSectionMarkings.default);
        this.setAttributeValue("distributionChannelsDiffData", null);
    }

    private _onReloaded_Genres() {
        this.expanderGenres.setMarking(this.genresList.hasData() ? ExpandableSectionMarkings.hasContent : ExpandableSectionMarkings.default);
    }

    private _onChange_EvTask(data) {
        this.expanderEvTask.setMarking(this.evTaskList.hasData() ? ExpandableSectionMarkings.hasContent : ExpandableSectionMarkings.default);
    }

    private _onReloaded_EvTask() {
        this.expanderEvTask.setMarking(this.evTaskList.hasData() ? ExpandableSectionMarkings.hasContent : ExpandableSectionMarkings.default);
        this.setAttributeValue("evTaskDiffData", null);
    }


    private _onPrivilegesLoaded() {
        this.isPrivilegesLoaded = true;


        this.setData(this.entity);

        this._handlePrivileges();
    }

    private _enableCopy(enable: boolean) {
        if (this.isEmbeddedInTab) {
            if (enable) {
                this.requestContextButton({
                    callback: lang.hitch(this, this.cloneBooking),
                    label: this.translate("General_Copy"),
                    iconClass: "fas fa-clone",
                    placement: "primarymenu",
                    permanent: false,
                    name: "clone"
                });
            }
        }
    }

    private _enableEdit(enable: boolean) {
        let isNew = this.entityId ? false : true;

        if (this.isEmbeddedInTab) {

            if (enable) {
                this.createDefaultButton("save", lang.hitch(this, this.saveData), false);
                if (!isNew) this.createDefaultButton("rollback", lang.hitch(this, this.handleRollback), false);
                if (!isNew) this.createDefaultButton("reload", lang.hitch(this, this.reloadEntity), true);
            }
        } else if (this.dlg) {

        }

        this.disableNode(this.formContainer, !enable);

        this.readonly = !enable;
    }

    private handleRollback(){
        this.rollback();
        this.serviceBookingList.setup({ active: this.entity?.service, canceled: this.entity?.serviceCanceled }, this.entity);
    }

    /** Die Rechte für das Entity müssen zu dem Zeitpunkt schon geladen sein! */
    private _handlePrivileges() {

        if (this.entityId && !this.webPrivilegeManager.isLoaded(this.entityId, ["EvBooking_Read"])) {
            alert("Das Recht 'EvBooking_Read' ist nicht geladen. Das deutet auf einen Fehler in der Konfiguration in evis hin.");
        }

        this.hasUserRole("EvBooking_Edit", lang.hitch(this, this._enableEdit), this.entity);

        if (this.hasFeature("EvBooking/Copy") && !!this.entityId) {
            this.hasUserRole("EvBooking_Create", lang.hitch(this, this._enableCopy), this.entity);
        }

        if (this.hasFeature("EvBooking/EvCast")) {
            this.expanderEvCast.setMarking(this.entity?.cast?.length ? ExpandableSectionMarkings.hasContent : ExpandableSectionMarkings.default);

            if (this.hasUserRole("EvCast_Edit", null, this.entity)) {
                this.castList.on("change", lang.hitch(this, this._onChange_EvCast));
            }

            this.hideNode(this.sectionEvCast, !this.hasUserRole("EvCast_Read", null, this.entity));
        }

        if (this.hasFeature("Mozarteum/EvCast")) {
            this.castListMoz.setup(this.entity?.cast, this.entityId);
            this.expanderEvCastMoz.setMarking(this.entity?.cast?.length ? ExpandableSectionMarkings.hasContent : ExpandableSectionMarkings.default);

            if (this.hasUserRole("EvCast_Edit", null, this.entity)) {
                this.castListMoz.on("change", lang.hitch(this, this._onChange_EvCastMoz));
            }

            this.hideNode(this.sectionEvCastMoz, !this.hasUserRole("EvCast_Read"));
        }

        if (this.hasFeature("EvBooking/EvProgram")) {
            this.expanderEvProgram.setMarking(this.entity?.program?.length ? ExpandableSectionMarkings.hasContent : ExpandableSectionMarkings.default);

            if (this.hasUserRole("EvProgram_Edit", null, this.entity)) {
                this.programList.on("change", lang.hitch(this, this._onChange_EvProgram));
            }

            this.hideNode(this.sectionEvProgram, !this.hasUserRole("EvProgram_Read", null, this.entity));
        }

        if (this.hasFeature("EvBooking/EvService")) {

            this.serviceBookingList.setup({ active: this.entity?.service, canceled: this.entity?.serviceCanceled }, this.entity);
            this.expanderEvServiceBookings.setMarking(this.entity?.service?.length || this.entity?.serviceCanceled?.length ? ExpandableSectionMarkings.hasContent : ExpandableSectionMarkings.default);


            if (this.hasUserRole("Service_Edit", null, this.entity)) {
                

                this.serviceBookingList.on("change", lang.hitch(this, this._onChange_EvServiceBookings));
                this.serviceBookingList.on("changeCanceled", lang.hitch(this, this._onChange_EvServiceBookingsCanceled));
            }

            if (FeatureHelpers.hasFeature("EvService/PhysicalResources")) {
                this.serviceBookingList.on("resourceOverload", lang.hitch(this, this._onResourceOverload_EvServiceBookings));
            }

            this.serviceBookingList.setRoomId(this.getAttributeValue("ref_ev_room.ID"));

            this.hideNode(this.sectionEvServiceBooking, !this.hasUserRole("Service_Read", null, this.entity));
        }

        if (this.hasFeature("EvBooking/EvCategory")) {
            this.categoriesList.setup(this.entity?.evCategories, this.entity);
            this.expanderEvCategories.setMarking(this.entity?.evCategories?.length ? ExpandableSectionMarkings.hasContent : ExpandableSectionMarkings.default);

            if (this.hasUserRole("EvCategory_Edit", null, this.entity)) {
                this.categoriesList.on("change", lang.hitch(this, this._onChange_EvCategory));
            }

            this.hideNode(this.sectionEvCategories, !this.hasUserRole("EvCategory_Read", null, this.entity));
        }

        if (this.hasFeature("EvBooking/Overlappings")) {
            this.overlappingsForm.on("dataReceived", lang.hitch(this, this._onOverlappingsLoaded));
        }

        if (this.hasFeature("EvBooking/TicketsCapacity")) {
            this.addOnchanged("ref_audience_seating_layouts", lang.hitch(this, this._onChanged_SeatingLayout));
        }

        if (this.hasUserRole(["OM", "EvBooking_OM"])) {

            this.orchestraEmploymentsList.setup(this.entity?.orchestraEmployments, this.entityId);
            this.expanderOrchestraEmployments.setMarking(this.entity?.orchestraEmployments?.length ? ExpandableSectionMarkings.hasContent : ExpandableSectionMarkings.default);

            if (this.hasUserRole("OrchestraEmployment_Edit", null, this.entity)) {
                this.orchestraEmploymentsList.on("change", lang.hitch(this, this._onChange_OrchestraEmployments));
            }

            this.hideNode(this.sectionOrchestraEmployments, !this.hasUserRole("EvBooking_OM", null, this.entity));

        } else {
            this.hideNode(this.sectionOrchestraEmployments);
        }

        this.hideNode(this.sectionFilelist);
        if (this.hasFeature("EvBooking/FileManage")) {
            // noch nicht ganz fertig!!

            if (this.hasUserRole("Files_Read") && this.hasUserRole("EvBooking_Files", null, this.entity)) {
                this.hideNode(this.sectionFilelist, false);

                let files = [];
                let mozFiles = [];
                let projectFiles = [];
                if (this.sourceData) {
                    files = this.sourceData.existingFiles;
                    mozFiles = this.sourceData.mozFiles
                    projectFiles = this.sourceData.projectFiles
                }

                if (files?.length || projectFiles?.length) {
                    this.expanderFilelist.setMarking(ExpandableSectionMarkings.hasContent);
                } else {
                    this.expanderFilelist.setMarking(ExpandableSectionMarkings.default);
                }

                this.filelist.setup(files, this.entityId, projectFiles);
                this.mozFilelist.setup(mozFiles, this.entityId, []);
                this.mozPrintFilelist.setup(files, this.entityId, projectFiles);

                //this.filelist.startup(); // ES GEHT MIT INHERITED EINFACH NICHT, WEISS DER KUCKUCK WARUM

                if (this.hasUserRole("Files_Edit")) {
                    this.filelist.on("change", lang.hitch(this, this._onChange_Files));

                    if (this.hasFeature("Mozarteum/AdvertisingFiles")) {
                        this.mozFilelist.on("change", lang.hitch(this, this._onChange_MozFiles));
                    }

                    if (this.hasFeature("Mozarteum/PrintFiles")) {
                        this.mozPrintFilelist.on("change", lang.hitch(this, this._onChange_MozPrintFiles));
                    }
                }
            }
        }

        if (this.hasFeature("EvBooking/RoomSelector")) {
            if (this.hasFeature("EvBooking/Base")) this.locationForm.placeAt(this.baseForm.sectionLocation);
            if (this.hasFeature("EvBooking/BasePrivilage")) this.locationForm.placeAt(this.baseFormPriv.sectionLocation);
        }

        this.handleEvProcessList();
        this.handleTodoAppointmentsList()
        this.handleEvTaskList();
        this.handleDistributionChannelList();
        this.handleGenresList();
        this.handleInvolvedAddressesList();
        this.handleClasslevelList();
        this.handleDresccodeList();

    }

    private handleEvProcessList(): void {
        if (!this.hasUserRole("EvBooking_EvProcess") || !this.hasFeature("EvBooking/EvProcess")) {
            this.UiModder.domConstruct.destroy(this.sectionEvProcess);
            return;
        }

        if (this.evProcessTable) {
            this.evProcessTable.destroy();
            this.evProcessTable = null;
        }


        if (!this.entity) {
            this.hideNode(this.sectionEvProcess);
            return;
        }

        let evProcesses = this.sourceData ? this.sourceData.evProcesses : [];

        this.setAttributeValue("evProcessDiffData", null);
        this.resetDirty();

        this.evProcessTable = new EvProcessTable("booking");
        this.evProcessTable.setData(evProcesses, this.entity as any);
        this.evProcessTable.on("change", lang.hitch(this, this._onChangeEvProcessTable));
        this.evProcessTable.on("reloaded", lang.hitch(this, this._onReloadEvProcessTable));

        this.evProcessTable.placeAt(this.sectionEvProcess);

        this.hideNode(this.sectionEvProcess, false);
    }

    _onChangePublicStatus(isPublic: boolean) {
        if (!this.hasFeature("EvBooking/PublicCapacityAlwaysEnabled")) this.ticketsCapacityForm.setReadonly(!isPublic);
        this.setAttributeValue("is_public", isPublic);
        this.monitorIsPublicState("is_public");
    }

    private _onChangeEvProcessTable(diffData) {
        this.setAttributeValue("evProcessDiffData", diffData);
    }

    private _onReloadEvProcessTable() {
        this.setAttributeValue("evProcessDiffData", null);
    }

    private handleInvolvedAddressesList(): void {
        if (!this.hasFeature("EvBooking/InvolvedAddresses")) {
            this.hideNode(this.sectionInvolvedAddresses);
            this.UiModder.domConstruct.destroy(this.sectionInvolvedAddresses);
            return;
        }


        if (this.involvedAddressesList != null) {
            this.involvedAddressesList.destroy();
            this.involvedAddressesList = null;
        }


        if (!this.getEntityId()) {
            this.hideNode(this.sectionInvolvedAddresses);
            return;
        }

        this.hideNode(this.sectionInvolvedAddresses, false);

        this.involvedAddressesList = new InvolvedAddressesEvBooking();

        this.involvedAddressesListExpander.setContent(this.involvedAddressesList);
        this.involvedAddressesList.setCurrentBooking(this.entity);

        let addressesList = this.getAttributeValue("involvedAddresses") as any;

        this.involvedAddressesList.setData(addressesList);

        this.involvedAddressesListExpander.setMarking(addressesList?.length ? ExpandableSectionMarkings.hasContent : ExpandableSectionMarkings.default);

        if (this.hasUserRole("EvBooking_InvolvedAddresses", null, this.entity)) {
            this.involvedAddressesList.on("InvolvedAddresses_DataChanged", lang.hitch(this, this._onChange_InvolvedAddresses));
        }
    }

    private _onChange_InvolvedAddresses(data) {
        this.involvedAddressesListExpander.setMarking(this.involvedAddressesList.hasData() ? ExpandableSectionMarkings.hasContent : ExpandableSectionMarkings.default);

        this.setAttributeValue("involvedAddressesDiffData", data, true);
    }

    private handleDistributionChannelList(): void {
        if (this.hasFeature("EvBooking/DistributionChannels") && this.hasUserRole("EvBooking_DistributionChannels")) {
            this.setAttributeValue("distributionChannelsDiffData", null);
            this.distributionChannelList.on("change", lang.hitch(this, this._onChange_DistributionChannels));
            this.distributionChannelList.on("reloaded", lang.hitch(this, this._onReloaded_DistributionChannels));
            this.addOnchanged("ref_ev_project", (attr: string, newValue: Date, oldValue: any) => { this.distributionChannelList.updateSedFilterValues(attr, newValue) })
            this.resetDirty();
        }
    }

    private handleGenresList(): void {
        if (this.hasFeature("EvBooking/Genres") && this.hasUserRole("EvBooking_Genres")) {
            this.setAttributeValue("genresDiffData", null);
            this.genresList.on("change", lang.hitch(this, this._onChange_Genres));
            this.genresList.on("reloaded", lang.hitch(this, this._onReloaded_Genres));
            this.resetDirty();
        }
    }

    private handleEvTaskList(): void {
        if (this.hasFeature("EvBooking/EvTask") && this.hasUserRole("EvBooking_EvTask")) {
            this.setAttributeValue("evTaskDiffData", null);
            this.evTaskList.on("change", lang.hitch(this, this._onChange_EvTask));
            this.evTaskList.on("reloaded", lang.hitch(this, this._onReloaded_EvTask));
            this.resetDirty();
        }
    }

    private handleTodoAppointmentsList(): void {
        if (!this.hasUserRole("EvBooking_TodoAppointments") || !this.hasFeature("EvBooking/TodoAppointments")) {
            this.UiModder.domConstruct.destroy(this.sectionTodoAppointments);
            return;
        }

        if (this.todoAppointmentsTable) {
            this.todoAppointmentsTable.destroy();
            this.todoAppointmentsTable = null;
        }

        if (!this.entity) {
            this.hideNode(this.sectionTodoAppointments);
            return;
        }

        let todoAppointments = this.sourceData ? this.sourceData.todoAppointments : [];

        this.setAttributeValue("todoAppointmentsDiffData", null);
        this.resetDirty();

        this.todoAppointmentsTable = new TodoAppointmentsTable();
        this.todoAppointmentsTable.setData(todoAppointments, this.entity as any);
        this.todoAppointmentsTable.on("change", lang.hitch(this, this._onChangeTodoAppointmentTable));
        this.todoAppointmentsTable.on("reloaded", lang.hitch(this, this._onReloadTodoAppointmentTable));

        this.todoAppointmentsTable.placeAt(this.sectionTodoAppointments);

        this.hideNode(this.sectionTodoAppointments, false);
    }

    private _onChangeTodoAppointmentTable(diffData): void {
        this.setAttributeValue("todoAppointmentsDiffData", diffData);
    }

    private _onReloadTodoAppointmentTable(): void {
        this.setAttributeValue("todoAppointmentsDiffData", null);
    }

    private handleClasslevelList(): void {
        if (this.classLevelList) {
            this.classLevelList.destroy();
            this.classLevelList = null;
        }

        if (this.hasUserRole("EvBooking_Classlevel") && this.hasFeature("EvBooking/Classlevel")) {
            let classlevel = this.sourceData ? this.sourceData.classlevel : [];
            let ID = this.getAttributeValue("ID");

            this.setAttributeValue("classlevelDiffData", null);

            this.classLevelList = new ClasslevelList();
            this.classLevelList.setData(classlevel);
            this.classLevelList.setBookingID(ID);
            this.classLevelList.on("change", lang.hitch(this, this._onChangeClasslevelList));
            this.classLevelList.on("reload", lang.hitch(this, this._onReloadClasslevelList));

            this.classLevelList.placeAt(this.expanderClasslevel);

            this._setClasslevelExpanderMarking();
        }
    }

    private _onChangeClasslevelList(diffData): void {
        this.setAttributeValue("classlevelDiffData", diffData);
        this._setClasslevelExpanderMarking();
    }

    private _onReloadClasslevelList(): void {
        this.setAttributeValue("classlevelDiffData", null);
        this._setClasslevelExpanderMarking();
    }

    private _setClasslevelExpanderMarking(): void {
        this.expanderClasslevel.setMarking(this.classLevelList && this.classLevelList.hasData() ? ExpandableSectionMarkings.hasContent : ExpandableSectionMarkings.empty);
    }

    private handleDresccodeList(): void {
        if (this.dresscodeList) {
            this.dresscodeList.destroy();
            this.dresscodeList = null;
        }

        if (this.hasUserRole("EvBooking_Dresscode") && this.hasFeature("EvBooking/Dresscode")) {
            let dresscode = this.sourceData ? this.sourceData.dresscode : [];
            let ID = this.getAttributeValue("ID");

            this.setAttributeValue("dresscodeDiffData", null);

            this.dresscodeList = new DresscodeList();
            this.dresscodeList.setData(dresscode);
            this.dresscodeList.setBookingID(ID);
            this.dresscodeList.on("change", lang.hitch(this, this._onChangeDresscodeList));
            this.dresscodeList.on("reload", lang.hitch(this, this._onReloadDresscodeList));

            this.dresscodeList.placeAt(this.expanderDresscode);

            this._setDresscodeExpanderMarking();
        }
    }

    private _onChangeDresscodeList(diffData): void {
        this.setAttributeValue("dresscodeDiffData", diffData);
        this._setDresscodeExpanderMarking();
    }

    private _onReloadDresscodeList(): void {
        this.setAttributeValue("dresscodeDiffData", null);
        this._setDresscodeExpanderMarking();
    }

    private _setDresscodeExpanderMarking(): void {
        this.expanderDresscode.setMarking(this.dresscodeList && this.dresscodeList.hasData() ? ExpandableSectionMarkings.hasContent : ExpandableSectionMarkings.empty);
    }


    //----------------------- LC -------------------------start
    postCreate(): void {
        super.postCreate.apply(this, arguments as any);

        this.displaynameProperty = "ev_booking_name";

        if (!this.webPrivilegeManager) {
            alert("missing webPrivilegeManager! this module is needed for booking editor to work.");
            return;
        }

        //this.hasUserRole("dummy", lang.hitch(this, this._handleSections)); // Callback wird ggf. asynchron ausgeführt, falls die Session noch nicht gleich da ist!

        this.RequestManager.handleAs = "jsonWithDate";

        if (this.hasFeature("EvBooking/LegacyEditor")) {
            this.legacyForm.adjustSectionsVisibility();
            this.legacyForm.on("dirty", lang.hitch(this, this._onDirty_LegacyForm));
            this.legacyForm.on("bookingEditorPricelistCalculationResponse", lang.hitch(this, this.reloadEntity));
            this.legacyForm.on("bookingEditorAssignAssociateResponse", lang.hitch(this, this.reloadEntity));
        }

        if (!this.hasFeature("EvBooking/TicketsCapacity") && !this.hasFeature("EvBooking/PublicStatus")) this.hideNode(this.sectionVisitor, true);

        if (FeatureHelpers.hasFeature("EvBooking/Marketing") && this.hasUserRole("EvBooking_Marketing")) {
            this.marketingEditor.on("change", lang.hitch(this, this._onChange_Marketing));
        }

        if (FeatureHelpers.hasFeature("EvBooking/Sales") && this.hasUserRole("EvBooking_Sales")) {
            this.salesEditor.on("change", lang.hitch(this, this._onChange_Sales))
        }

        if (this.hasFeature("EvBooking/BasePrivilage")) this.baseFormPriv.on("displayname", lang.hitch(this, this._onDisplaynameChange));
        else this.baseForm.on("displayname", lang.hitch(this, this._onDisplaynameChange));
        //this.baseForm.on("dirty", lang.hitch(this, this.onDirtyChange));

        this.addOnchanged("ref_ev_room", lang.hitch(this, this._onChanged_EvRoom));
        this.addOnchanged("date_start", lang.hitch(this, this._onChanged_Dates));
        this.addOnchanged("date_end", lang.hitch(this, this._onChanged_Dates));

        this.addOnchanged("ref_ev_activity_status", lang.hitch(this, this._onChanged_ActivityStatus));

        if (this.hasFeature("EvBooking/NotePrivilage")) {
            this.hideNode(this.noteBase);

        }

    //    this.startup();
    }
    startup(): void {
        //console.debug(this.id + " STARTUP", "cancel startup?", this.isStarted);

        if (this.isStarted) return;
        super.startup.apply(this, arguments as any);

        this.selfSetup();

        this.isStarted = true;



        if (!this.entityId) this._handlePrivileges();


        if (this.hasFeature("Mozarteum/BookingBase")) {
            // erstmal beide ausblenden bis der Aktivitätsstatus gewählt wurde
            if (this.hasFeature("Mozarteum/EvCast")) {
                this.hideNode(this.sectionEvCast);
                this.hideNode(this.sectionEvCastMoz);
            }
        }

        this.monitorIsPublicState("start");
    }

    private isStarted: boolean = false;
    private isPrivilegesLoaded: boolean = false;
}

export default mdsWidget(EvBookingEditorV2);
